import React from "react";
import { Helmet } from "react-helmet";
import PortfolioSection from "../components/PortfolioSection";

function Portfolio() {
  return (
    <div>
      <Helmet>
        <title>포트폴리오 - 채움기획</title>
        <meta name="description" content="채움기획의 포트폴리오를 확인하세요. 뷰티, 미용실, 맛집, 병의원, 마사지 등에서의 성공적인 광고 사례를 제공합니다." />
        <meta name="keywords" content="포트폴리오, 채움기획, 광고 성공 사례, portfolio" />
        <link rel="canonical" href="https://cheumad.kr/portfolio"/>
        <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "BreadcrumbList",
              "@id": "https://cheumad.kr/portfolio/#breadcrumblist",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "@id": "https://cheumad.kr/#listItem",
                  "position": 1,
                  "name": "홈",
                  "item": "https://cheumad.kr/",
                  "nextItem": "https://cheumad.kr/portfolio/#listItem"
                },
                {
                  "@type": "ListItem",
                  "@id": "https://cheumad.kr/portfolio/#listItem",
                  "position": 2,
                  "name": "포트폴리오",
                  "previousItem": "https://cheumad.kr/#listItem"
                }
              ]
            },
            {
              "@type": "Organization",
              "@id": "https://cheumad.kr/#organization",
              "name": "채움기획",
              "url": "https://cheumad.kr/",
              "logo": "https://cheumad.kr/logo.png",
              "contactPoint": [
                {
                  "@type": "ContactPoint",
                  "Owner": "홍성준",
                  "E-mail": "fate_ad@naver.com",
                }
              ]
            },
            {
              "@type": "WebPage",
              "@id": "https://cheumad.kr/portfolio/#webpage",
              "url": "https://cheumad.kr/portfolio/",
              "name": "포트폴리오 - 채움기획",
              "inLanguage": "ko-KR",
              "isPartOf": {
                "@id": "https://cheumad.kr/#website"
              },
              "breadcrumb": {
                "@id": "https://cheumad.kr/portfolio/#breadcrumblist"
              },
              "datePublished": "2025-01-01T00:00:00+09:00",
              "dateModified": "2025-01-01T00:00:00+09:00"
            },
            {
              "@type": "WebSite",
              "@id": "https://cheumad.kr/#website",
              "url": "https://cheumad.kr/",
              "name": "채움기획",
              "inLanguage": "ko-KR",
              "publisher": {
                "@id": "https://cheumad.kr/#organization"
              }
            },
            {
              "@type": "SiteNavigationElement",
              "@id": "https://cheumad.kr/#siteNavigation",
              "name": ["포트폴리오", "문의하기"],
              "url": ["https://cheumad.kr/portfolio", "https://cheumad.kr/contact"]
            }
          ]
        })}
        </script>
      </Helmet>
      <PortfolioSection />
    </div>
  );
}

export default Portfolio;
